<script setup lang="ts">
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import { useLocale } from '~/composables/useLocale'
import { type Dayjs, parseDate } from '~/utils/date'

const props = withDefaults(
  defineProps<{
    modelValue: Dayjs
    placeholder?: string
    disabledDates?: (date: Date) => boolean
  }>(),
  {
    placeholder: undefined,
    disabledDates: () => false,
  }
)

const { currentLocale } = useLocale()
const date = computed<Date>(() => props.modelValue.toDate())

const emit = defineEmits<{
  (e: 'update:modelValue', value: Dayjs): void
}>()

const pick = (value: Date) => {
  emit('update:modelValue', parseDate(value))
}
</script>

<template>
  <div>
    <VueDatePicker
      :placeholder="placeholder"
      :model-value="date"
      :format="'yyyy-MM-dd'"
      :locale="currentLocale"
      :auto-apply="true"
      :enable-time-picker="false"
      input-class-name="input"
      :config="{
        // trueにするとBaseDrawerのclickOutsideが誤反応してしまうため注意(onClickOutSide内のcapture clickイベントのみに反応して閉じてしまう)
        allowStopPropagation: false,
      }"
      :teleport="true"
      :disabled-dates="disabledDates"
      @update:model-value="pick"
    ></VueDatePicker>
  </div>
</template>
